import type { AuthCredential } from '@/types'

export default function () {
  const config = useRuntimeConfig()

  const credential = useCookie<AuthCredential | null>('auth-token', {
    expires: new Date(Date.now() + 12096e5), // 2 weeks from now
    sameSite: 'lax',
    path: '/',
    watch: true
  })

  async function clearCredential() {
    if (process.client) {
      useCookie('auth-token').value = null
      const { $getLogoutRedirectUrl } = useAuth()
      window.location.replace($getLogoutRedirectUrl())
    }
  }
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  function onRequest(context: any) {
    context.options.headers = context.options.headers || {}
    // biome-ignore lint/complexity/useLiteralKeys: <explanation>
    context.options.headers['Accept'] = 'application/json'
    context.options.headers.authorization = credential.value?.token ? `Bearer ${credential.value?.token}` : ''
  }
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  function onResponseError(context: any) {
    // console.log(context)
    if (context.response.status === 401) {
      return clearCredential()
    }
  }

  const requestOptions = {
    baseURL: config.public.API_ENDPOINT,
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    onRequest: (Context: any) => onRequest(Context),
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    onResponseError: (context: any) => onResponseError(context)
  }
  return {
    requestOptions
  }
}
